import script from "./VitaSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaSelect.vue?vue&type=script&setup=true&lang=ts"

import "./VitaSelect.vue?vue&type=style&index=0&id=239660ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239660ea"]])

export default __exports__